import { render, staticRenderFns } from "./setrolebatch.vue?vue&type=template&id=33b05dee"
import script from "./setrolebatch.vue?vue&type=script&lang=js"
export * from "./setrolebatch.vue?vue&type=script&lang=js"
import style0 from "./setrolebatch.vue?vue&type=style&index=0&id=33b05dee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports